import React, { useEffect, useState } from "react";
import { jobsApi, applicationsApi } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Briefcase } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function ClientPortal() {
  const { user } = useAuth();
  const [jobs, setJobs] = useState([]);
  const [apps, setApps] = useState([]);
  useEffect(() => {
    jobsApi.list().then((j) => setJobs(j.filter((x) => x.client === user?.org).slice(0, 8).length ? j.filter((x) => x.client === user?.org) : j.slice(0, 6)));
    applicationsApi.list().then(setApps);
  }, [user]);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-1">Client Portal</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">{user?.org || "Your requisitions"}</h1>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        {jobs.map((j) => {
          const jApps = apps.filter((a) => a.job_id === j.id);
          return (
            <Card key={j.id} className="border-border shadow-none p-5">
              <div className="flex items-start justify-between">
                <div className="h-10 w-10 rounded-md bg-[#0047AB]/10 text-[#0047AB] grid place-items-center"><Briefcase className="h-5 w-5" /></div>
                <Badge variant="outline" className="text-[10px] font-mono uppercase tracking-wider">{j.status}</Badge>
              </div>
              <h3 className="font-display font-bold text-lg tracking-tight mt-4">{j.title}</h3>
              <div className="text-sm text-muted-foreground">{j.location} · {j.employment_type}</div>
              <div className="mt-4 grid grid-cols-3 border border-border rounded-md overflow-hidden">
                <div className="p-3 border-r border-border">
                  <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Submitted</div>
                  <div className="font-display text-xl font-bold">{jApps.length}</div>
                </div>
                <div className="p-3 border-r border-border">
                  <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Interviewing</div>
                  <div className="font-display text-xl font-bold">{jApps.filter((a) => a.stage === "interviewed").length}</div>
                </div>
                <div className="p-3">
                  <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Placed</div>
                  <div className="font-display text-xl font-bold">{jApps.filter((a) => a.stage === "placed").length}</div>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
